<router-outlet></router-outlet>
<gsti-loader></gsti-loader>

<div bsModal #childModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h4 id="dialog-child-name" class="modal-title pull-left">
                    <strong>{{labelSession.title}}</strong>
                </h4>
                <div class="spriteBtns">
                    <button type="button" class="closebtns" title="Close" (click)="hideChildModal()">
                        <svg>
                            <use [attr.xlink:href]="srcPath.closeIcon"></use>
                        </svg>
                    </button>
                </div>
            </div>
            <div class="modal-body">
                <p>{{idleState}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn commonBtn confirmBtn" (click)="stay()">{{labelSession.btnCancel}}</button>
                <button type="button" class="btn commonBtn confirmBtn" (click)="logout()">{{labelSession.btnConfirm}}</button>
            </div>
        </div>
    </div>
</div>

<div bsModal #slowNetworkModal="bs-modal" class="modal fade" style="z-index: 2000000001;" tabindex="-1" role="dialog"
    aria-labelledby="dialog-child-name">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h4 id="dialog-child-name" class="modal-title pull-left" style="padding-left: 0px !important">
                    <strong>{{labelLoadingSession.title}}</strong>
                </h4>
                <div class="spriteBtns">
                    <button type="button" class="closebtns" title="Close" (click)="onStaySlowRequest()">
                        <svg>
                            <use [attr.xlink:href]="srcPath.closeIcon"></use>
                        </svg>
                    </button>
                </div>
            </div>
            <div class="modal-body">
                <p>{{labelLoadingSession.message}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn commonBtn confirmBtn"
                    (click)="onStaySlowRequest()">{{labelLoadingSession.btnCancel}}</button>
                <button type="button" class="btn commonBtn confirmBtn"
                    (click)="onLeaveSlowRequest()">{{labelLoadingSession.btnConfirm}}</button>
            </div>
        </div>
    </div>
</div>
<div bsModal #errorNetworkModal="bs-modal" class="modal fade" style="z-index: 2000000001;" tabindex="-1" role="dialog"
    aria-labelledby="dialog-child-name">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h4 id="dialog-child-name" class="modal-title pull-left" style="padding-left: 0px !important">
                    <strong>{{labelErrorLoadingSession.title}}</strong>
                </h4>
                <div class="spriteBtns">
                    <button type="button" class="closebtns" title="Close" (click)="onOkErrorRequest()">
                        <svg>
                            <use [attr.xlink:href]="srcPath.closeIcon"></use>
                        </svg>
                    </button>
                </div>
            </div>
            <div class="modal-body">
                <p>{{labelErrorLoadingSession.message}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn commonBtn confirmBtn"
                    (click)="onOkErrorRequest()">{{labelErrorLoadingSession.btnConfirm}}</button>
            </div>
        </div>
    </div>
</div>
<div bsModal #neworkFailureModal="bs-modal" class="modal fade" style="z-index: 2000000001;" tabindex="-1" role="dialog"
    aria-labelledby="dialog-child-name">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h4 id="dialog-child-name" class="modal-title pull-left" style="padding-left: 0px !important">
                    <strong>{{labelNetworkFailureSession.title}}</strong>
                </h4>
                <div class="spriteBtns">
                    <button type="button" class="closebtns" title="Close" (click)="onOkErrorRequest()">
                        <svg>
                            <use [attr.xlink:href]="srcPath.closeIcon"></use>
                        </svg>
                    </button>
                </div>
            </div>
            <div class="modal-body">
                <p>{{labelNetworkFailureSession.message}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn commonBtn confirmBtn"
                    (click)="onExitNWFailure()">{{labelNetworkFailureSession.btnConfirm}}</button>
            </div>
        </div>
    </div>
</div>

<app-popup-host/>